<template>
    <router-link v-if="hasFacture" :to="{name: 'market-billing-detail', params: {uid: object.facture}}">
      {{ facture.invoiceNumber }}
    </router-link>
  </template>
  
  <script>
  import { mapGetters } from 'vuex';
  export default {
      props: {
          object: {type: Object, required: true}
      },
      computed: {
          ...mapGetters({
              factures: 'market/factures'
          }),
          facture(){
              return this.factures.find(f=> f.uid === this.object.facture);
          },
          hasFacture(){
              return!!this.facture;
          }
      }
  
  }
  </script>